"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _sms = require("@/api/sms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'Login',
  data: function data() {
    return {
      formInline: {
        account: '',
        password: ''
      },
      ruleInline: {
        account: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      passwordType: 'password',
      loading: false
    };
  },
  created: function created() {
    var _this = this;

    document.onkeydown = function (e) {
      var key = window.event.keyCode;

      if (key === 13) {
        _this.handleSubmit('formInline');
      }
    };
  },
  methods: {
    showPwd: function showPwd() {
      var _this2 = this;

      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }

      this.$nextTick(function () {
        _this2.$refs.password.focus();
      });
    },
    handleSubmit: function handleSubmit(name) {
      var _this3 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          (0, _sms.configApi)(_this3.formInline).then( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
              return _index.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _this3.$message.success('登录成功!');

                      _this3.$store.dispatch('user/isLogin');

                      _this3.$emit('on-Login');

                      _this3.loading = false;

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function () {
            _this3.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    // 修改密码
    changePassword: function changePassword() {
      this.$emit('on-change');
    },
    changeReg: function changeReg() {
      this.$emit('on-changes');
    }
  }
};
exports.default = _default;